export class MarketplaceFilter {
  constructor(container) {
    this.container = container;
    this.searchInput = container.querySelector('[data-search]');
    this.searchIcon = container.querySelector('[data-search-icon]');
    this.searchClear = container.querySelector('[data-search-clear]');
    this.featuredSection = container.querySelector('[data-featured-section]');
    this.categoryButtons = container.querySelectorAll('[data-filter-category]');
    this.cards = container.querySelectorAll('[data-partner-card]');
    this.categorySections = container.querySelectorAll('[data-category-section]');
    this.noResults = container.querySelector('[data-no-results]');
    this.hero = container.querySelector('[data-hero]');

    this.searchQuery = '';
    this.activeCategory = '';
    this._lastTrackedQuery = '';

    this.bindEvents();
  }

  bindEvents() {
    // Search input
    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => {
        this.searchQuery = e.target.value.toLowerCase().trim();
        this.updateSearchUI();
        this.filter();
      });

      this.searchInput.addEventListener('blur', () => {
        const query = this.searchInput.value.trim();
        if (query && query !== this._lastTrackedQuery) {
          this._lastTrackedQuery = query;
          window.track('Partner Marketplace Search', { query });
        }
      });
    }

    // Clear button
    if (this.searchClear) {
      this.searchClear.addEventListener('click', () => {
        this.searchInput.value = '';
        this.searchQuery = '';
        this._lastTrackedQuery = '';
        this.updateSearchUI();
        this.filter();
      });
    }

    // Category buttons (filter by category + highlight active)
    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const slug = button.dataset.filterCategory;
        this.activeCategory = slug;
        this.updateCategoryUI();
        this.filter();
        requestAnimationFrame(() => {
          if (this.hero.getBoundingClientRect().bottom < 0) {
            window.scrollTo({ top: (this.hero.offsetTop + this.hero.offsetHeight), behavior: 'smooth' });
          }
        });

        window.track(
          'Partner Marketplace Click',
          { code: 'category', category: slug, category_name: button.textContent.trim()
        });
      });
    });
  }

  updateCategoryUI() {
    this.categoryButtons.forEach((b) => {
      const isActive = b.dataset.filterCategory === this.activeCategory;
      const dot = b.querySelector('.category-dot');
      if (dot) {
        dot.classList.toggle('hidden', !isActive);
      } else {
        b.classList.toggle('text-primary', isActive);
        b.classList.toggle('!font-bold', isActive);
      }
    });
  }

  updateSearchUI() {
    const hasQuery = this.searchQuery.length > 0;
    this.searchIcon?.classList.toggle('hidden', hasQuery);
    this.searchClear?.classList.toggle('hidden', !hasQuery);
    this.featuredSection?.classList.toggle('hidden', hasQuery);
  }

  filter() {
    let visibleCount = 0;

    // First: filter individual cards by search query
    this.cards.forEach((card) => {
      const name = (card.dataset.partnerName || '').toLowerCase();
      const description = (card.dataset.partnerDescription || '').toLowerCase();

      const matchesSearch =
        !this.searchQuery ||
        name.includes(this.searchQuery) ||
        description.includes(this.searchQuery);

      if (matchesSearch) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
    });

    // Show/hide category sections based on active category + visible cards
    this.categorySections.forEach((section) => {
      const slug = section.dataset.categorySection;
      const matchesCategory = !this.activeCategory || slug === this.activeCategory;
      const visibleCards = section.querySelectorAll('[data-partner-card]:not(.hidden)');

      if (matchesCategory && visibleCards.length > 0) {
        section.classList.remove('hidden');
        visibleCount += visibleCards.length;
      } else {
        section.classList.add('hidden');
      }
    });

    // Toggle no results message
    if (this.noResults) {
      this.noResults.classList.toggle('hidden', visibleCount > 0);
    }
  }
}
